export default __webpack_public_path__ + "static/media/notes-render.19460395.png";